import React from "react";
import { useSelector } from "react-redux";
import { showLoadingSelector } from "../../store/loading/selectors";
import { BeatLoader } from "@wf/components";

type Props = {
  alwaysShow?: boolean;
};

const Loading: React.FC<Props> = ({ alwaysShow = false }) => {
  const showLoading = useSelector(showLoadingSelector);
  if (!alwaysShow && !showLoading) {
    return null;
  }
  return <BeatLoader />;
};

export default Loading;
